import { Typography as MuiTypography, styled } from '@material-ui/core';

import { COLORS } from '../../theme/constants';

export const Subtext = styled(MuiTypography)(({ theme }) => ({
  ...theme.typography.body,
  color: COLORS.cozmosPurple2
}));
